<ion-header>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button fill="solid" (click)="cancel()">
        <ion-icon slot="start" name="close-circle-outline"></ion-icon>
        {{ 'General.Close' | translate }}
      </ion-button>
    </ion-buttons>
    <ion-title class="modal-title">{{ title | translate }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-grid>
    @if (customerTransactionEmail.logoUrl || customerTransactionEmail.logoFileName) {
      <ion-row class="center">
        <ion-col size="2"></ion-col>
        <!--<ion-col size="8"><img style="width:125px;" logo></ion-col>-->
        <ion-col size="8"><img style="width:125px;" [src]="logo"></ion-col>
        <ion-col size="2"></ion-col>
      </ion-row>
    }
    <ion-row class="center bold">
      <ion-col size="2"></ion-col>
      <ion-col size="8">
        <h2 class="no-margin bold">{{customerTransactionEmail.brandName}}</h2>
      </ion-col>
      <ion-col size="2"></ion-col>
    </ion-row>

    <ion-row class="center bold" style="padding-bottom:0!important;">
      <ion-col size="2" style="padding-bottom:0!important;"></ion-col>
      <ion-col size="12" style="padding-bottom:0!important;">
        <h3 class="no-margin fontsizer12">{{ 'Receipt.ShopAchat' | translate }}</h3>
      </ion-col>
      <ion-col size="2" style="padding-bottom:0!important;"></ion-col>
    </ion-row>
    <ion-row class="center bold no-padding">
      <ion-col size="2"></ion-col>
      <ion-col size="8">
        <h4 class="no-margin fontsizer12">{{ 'Receipt.OrderConfirmation' | translate }}</h4>
      </ion-col>
      <ion-col size="2"></ion-col>
    </ion-row>
    <ion-row class="center bold no-padding">
      <ion-col size="2"></ion-col>
      <ion-col size="8">
        <h4 class="no-margin fontsizer12">#{{ customerTransactionEmail.orderNumber }}</h4>
      </ion-col>
      <ion-col size="2"></ion-col>
    </ion-row>
    <ion-row>
      <!-- empty row-->
      &nbsp;
    </ion-row>
    <ion-row class="no-padding center uppercase fontsizer10">
      <ion-col size="2"></ion-col>
      <ion-col size="8">{{'Receipt.RecipientDetails' | translate}}</ion-col>
      <ion-col size="2"></ion-col>
    </ion-row>
    <ion-row class="no-padding center bold uppercase fontsizer10">
      <ion-col size="2"></ion-col>
      <ion-col size="8">{{customerTransactionEmail.customerName}}</ion-col>
      <ion-col size="2"></ion-col>
    </ion-row>
    <ion-row class="no-padding center fontsizer10">
      <ion-col size="2"></ion-col>
      <ion-col size="8">{{ customerTransactionEmail.billingAddress }}</ion-col>
      <ion-col size="2"></ion-col>
    </ion-row>
    <ion-row class="no-padding center bold uppercase fontsizer10">
      <ion-col size="2"></ion-col>
      <ion-col size="8">{{customerTransactionEmail.customerPhone}}</ion-col>
      <ion-col size="2"></ion-col>
    </ion-row>
    <ion-row class="no-padding center uppercase fontsizer10">
      <ion-col size="2"></ion-col>
      <ion-col size="8">{{customerTransactionEmail.customerEmail}}</ion-col>
      <ion-col size="2"></ion-col>
    </ion-row>
    @if (!customerTransactionEmail.onlyGiftCard) {
      <ion-row class="no-padding center uppercase fontsizer10">
        <ion-col size="2"></ion-col>
        <ion-col size="8">{{ customerTransactionEmail.translations.paymentType }}:
        {{customerTransactionEmail.ghostedPaymentNumber}}</ion-col>
        <ion-col size="2"></ion-col>
      </ion-row>
    }
    @if (customerTransactionEmail.useGiftCard) {
      <ion-row class="no-padding center uppercase fontsizer10">
        <ion-col size="2"></ion-col>
        <ion-col size="8">{{ customerTransactionEmail.translations.giftCardPayment }}:
        {{customerTransactionEmail.ghostedGiftCardNumber}}</ion-col>
        <ion-col size="2"></ion-col>
      </ion-row>
    }
    <ion-row class="no-padding center uppercase fontsizer10">
      <ion-col size="2"></ion-col>
      <ion-col size="8">
        {{ 'Receipt.Date' | translate}}:{{moment(customerTransactionEmail.orderDate).utcOffset(customerTransactionEmail.orderDate).format("MM/DD/YYYY HH:mm:ss")}}
      </ion-col>
      <ion-col size="2"></ion-col>
    </ion-row>
    <ion-row class="fontsizer10" style="margin-top:15px; border-bottom: 1px solid black;"></ion-row>
    <ion-row class="bold fontsizer10">
      <ion-col size="2"></ion-col>
      <ion-col size="8">{{customerTransactionEmail.storeName}}</ion-col>
      <ion-col size="2"></ion-col>
    </ion-row>
    <ion-row class="bold fontsizer10">
      <ion-col size="2"></ion-col>
      <ion-col size="8">{{customerTransactionEmail.storeAddress}}</ion-col>
      <ion-col size="2"></ion-col>
    </ion-row>
    <ion-row style="border-bottom: 1px solid black;"></ion-row>
    <ion-row class="bold fontsizer10">
      <ion-col size="2"></ion-col>
      @if (customerTransactionEmail.isDelivery && !customerTransactionEmail.seatInfo) {
        <ion-col size="8">
          {{'Receipt.DeliveryAddress' | translate}}
          {{customerTransactionEmail.reservedTime}}
        </ion-col>
      }
      @if (customerTransactionEmail.isShipping && !customerTransactionEmail.seatInfo) {
        <ion-col size="8">
          {{'Receipt.ShippingAddress' | translate}}
        </ion-col>
      }
      @if (!customerTransactionEmail.deliveryAddress && !customerTransactionEmail.seatInfo) {
        <ion-col size="8">
          {{ customerTransactionEmail.translations.takeout }}
          <span
            style="color: red;">*{{customerTransactionEmail.reservedTime}}*
          </span>
        </ion-col>
      }
      @if (customerTransactionEmail.seatInfo) {
        <ion-col size="8">
          {{ 'Checkout.Section' | translate }} {{ customerTransactionEmail.seatInfo.section }} - {{ 'Checkout.Row' | translate }} {{ customerTransactionEmail.seatInfo.row }} - {{ 'Checkout.Seat' | translate }} #{{ customerTransactionEmail.seatInfo.seatNumber }}
          <span
            style="color: red;">*{{customerTransactionEmail.reservedTime}}*
          </span>
        </ion-col>
      }
      <ion-col size="2"></ion-col>
    </ion-row>
    @if (customerTransactionEmail.deliveryAddress) {
      <ion-row class="fontsizer10">
        <ion-col size="2"></ion-col>
        <ion-col size="8">{{customerTransactionEmail.deliveryAddress}}</ion-col>
        <ion-col size="2"></ion-col>
      </ion-row>
    }
    @if (customerTransactionEmail.isEstimatedTimeUsed) {
      <ion-row class="fontsizer10">
        <ion-col size="2"></ion-col>
        <ion-col size="8">{{ 'General.EstimatedTime' | translate}} {{customerTransactionEmail.estimatedTime}}</ion-col>
        <ion-col size="2"></ion-col>
      </ion-row>
    }
    <ion-row class="separator"></ion-row>

    @if (hasAlcohol) {
      <ion-grid class="fontsizer10">
        <ion-row>
          <ion-col size="2"></ion-col>
          <ion-col size="8">
            @if (hasAlcohol) {
              <div class="alcohol-notice">
                {{ "Checkout.AlcoholItemNoticeText" | translate }}
              </div>
            }
          </ion-col>
          <ion-col size="2"></ion-col>
        </ion-row>
      </ion-grid>
    }

    @if (customerTransactionEmail.order.note) {
      <ion-grid class="fontsizer10">
        <ion-row>
          <ion-col size="2"></ion-col>
          @if (customerTransactionEmail.isShipping) {
            <ion-col size="8" style="color: red;">
              {{'Receipt.Note' | translate}}: {{ customerTransactionEmail.order.note}}
            </ion-col>
          }
          @if (!customerTransactionEmail.isShipping) {
            <ion-col size="8" style="color: red;">{{'Receipt.DeliveryNote' | translate}}:
            {{ customerTransactionEmail.order.note}}</ion-col>
          }
          <ion-col size="2"></ion-col>
        </ion-row>
      </ion-grid>
    }

    @for (item of customerTransactionEmail.order.orderItems; track item; let i = $index) {
      <ion-grid class="fontsizer10">
        <ion-row>
          <ion-col size="2"></ion-col>
          <ion-col size="5" [class.dotted-separator]="!item.note && !item.allergies && item.options.length == 0">
            <span>{{item.quantity}}x &nbsp;</span>{{item.name}}
            @if (item.itemDetailCombination) {
              @if (item.itemDetailCombination.color) {
                <ng-container style="font-size: 11px;">({{item.itemDetailCombination.color}}</ng-container>
              }
              @if (item.itemDetailCombination.size) {
                <ng-container style="font-size: 11px;"> + {{item.itemDetailCombination.size}})</ng-container>
              }
            }
          </ion-col>
          @if (item._hidePrice) {
            <ion-col size="2"
            [class.dotted-separator]="!item.note && !item.allergies && item.options.length == 0"></ion-col>
          }
          @if (!item._hidePrice) {
            <ion-col size="2" class="right"
              [class.dotted-separator]="!item.note && !item.allergies && item.options.length == 0">
              {{ item.totalPrice | currency}}
            </ion-col>
          }
          <ion-col size="2"></ion-col>
        </ion-row>
        @for (option of item.options; track option; let j = $index) {
          <ion-row class="options no-padding">
            <ion-col size="2"></ion-col>
            <ion-col size="1"
              [class.dotted-separator]="!item.note && !item.allergies && item.options.length > 0 && item.options[j+1] == undefined">
            </ion-col>
            <ion-col style="padding-left:30px;"
              [class.dotted-separator]="!item.note && !item.allergies && item.options.length > 0 && item.options[j+1] == undefined"
              size="5">
              @if (!item._hidePrice) {
                <span>{{option.quantity}}x</span>
                } {{option.name}}
                @if (option.itemDetailCombination) {
                  @if (option.itemDetailCombination) {
                    <ng-container style="font-size: 11px;">({{option.itemDetailCombination.color}}</ng-container>
                  }
                  @if (option.itemDetailCombination) {
                    <ng-container style="font-size: 11px;">+{{option.itemDetailCombination.size}})</ng-container>
                  }
                }
              </ion-col>
              <ion-col class="right"
                [class.dotted-separator]="!item.note && !item.allergies && item.options.length > 0 && item.options[j+1] == undefined"
                size="2">
                <!--{{option.price | currency}}-->
              </ion-col>
              <ion-col size="2"></ion-col>
            </ion-row>
          }
          @if (item.note) {
            <ion-row>
              <ion-col size="2"></ion-col>
              <ion-col size="8" [class.dotted-separator]="!item.allergies">{{'Receipt.Note' | translate}}:
                {{item.note}}
              </ion-col>
              <ion-col size="2"></ion-col>
            </ion-row>
          }
          @if (item.allergies) {
            <ion-row>
              <ion-col size="2"></ion-col>
              <ion-col size="8" class="dotted-separator" style="color: red;">{{'Receipt.Allergies' | translate}}:
              {{item.allergies}}</ion-col>
              <ion-col size="2"></ion-col>
            </ion-row>
          }
        </ion-grid>
      }
      <ion-row>
        <ion-col size="2"></ion-col>
        <ion-col class="separator" size="8"></ion-col>
        <ion-col size="2"></ion-col>
      </ion-row>
      <ion-row class="no-padding fontsizer10" style="margin-top:5px;">
        <ion-col size="2"></ion-col>
        <ion-col size="6">{{'General.Subtotal' | translate}}</ion-col>
        <ion-col class="right" size="2">{{ customerTransactionEmail.subtotal | currency}}</ion-col>
        <ion-col size="2"></ion-col>
      </ion-row>

      <!--before tax-->
      @if (customerTransactionEmail.isRebateApplied && customerTransactionEmail.isRebateBeforeTax) {
        <ion-row class="fontsizer10">
          <ion-col size="2"></ion-col>
          <ion-col size="6">{{'General.Promo' | translate}}</ion-col>
          <ion-col class="right" size="2">-{{ customerTransactionEmail.rebateAmount | currency}}</ion-col>
          <ion-col size="2"></ion-col>
        </ion-row>
      }
      @if (customerTransactionEmail.convenienceFee > 0.00) {
        <ion-row class="no-padding fontsizer10">
          <ion-col size="2"></ion-col>
          <ion-col size="6">{{'Store.ConvenienceFee' | translate}}</ion-col>
          <ion-col class="right" size="2">{{ customerTransactionEmail.convenienceFee | currency}}</ion-col>
          <ion-col size="2"></ion-col>
        </ion-row>
      }
      @if (customerTransactionEmail.deliveryAddress) {
        <ion-row class="no-padding fontsizer10">
          <ion-col size="2"></ion-col>
          @if (customerTransactionEmail.isDelivery) {
            <ion-col size="6">{{'General.DeliveryFee' | translate}}</ion-col>
          }
          @if (!customerTransactionEmail.isDelivery) {
            <ion-col size="6">{{'General.ShippingFee' | translate}}</ion-col>
          }
          <ion-col class="right" size="2">{{ customerTransactionEmail.deliveryFee | currency}}</ion-col>
          <ion-col size="2"></ion-col>
        </ion-row>
      }
      <!--on delivery-->
      @if (customerTransactionEmail.isRebateApplied && customerTransactionEmail.isRebateDelivery) {
        <ion-row class="fontsizer10">
          <ion-col size="2"></ion-col>
          <ion-col size="6">{{'General.Promo' | translate}}</ion-col>
          <ion-col class="right" size="2">-{{ customerTransactionEmail.rebateAmount | currency}}</ion-col>
          <ion-col size="2"></ion-col>
        </ion-row>
      }
      @for (tax of customerTransactionEmail.taxes; track tax) {
        <ion-row class="no-padding fontsizer10">
          <ion-col size="2"></ion-col>
          <ion-col size="6">{{ tax.name }}</ion-col>
          <ion-col class="right" size="2">{{ tax.amount | currency }}</ion-col>
          <ion-col size="2"></ion-col>
        </ion-row>
      }
      <ion-row class="no-padding fontsizer10">
        <ion-col size="2"></ion-col>
        <ion-col size="6">{{ (customerTransactionEmail.isDelivery ? 'Checkout.TipDelivery' : 'Checkout.Tip') | translate}}</ion-col>
        <ion-col class="right" size="2">{{ customerTransactionEmail.tip | currency}}</ion-col>
        <ion-col size="2"></ion-col>
      </ion-row>
      <!--after tax-->
      @if (customerTransactionEmail.isRebateApplied && customerTransactionEmail.isRebateAfterTax) {
        <ion-row class="fontsizer10">
          <ion-col size="2"></ion-col>
          <ion-col size="6">{{'General.Promo' | translate}}</ion-col>
          <ion-col class="right" size="2">-{{ customerTransactionEmail.rebateAmount | currency}}</ion-col>
          <ion-col size="2"></ion-col>
        </ion-row>
      }
      <ion-row class="no-padding fontsizer10">
        <ion-col size="2"></ion-col>
        <ion-col size="6">{{'General.Total' | translate}}</ion-col>
        <ion-col class="right" size="2">{{ customerTransactionEmail.total | currency}}</ion-col>
        <ion-col size="2"></ion-col>
      </ion-row>
      @if (customerTransactionEmail.useGiftCard) {
        <ion-row class="fontsizer10" class="no-padding">
          <ion-col size="2"></ion-col>
          <ion-col size="6">{{ customerTransactionEmail.translations.giftCard }}</ion-col>
          <ion-col class="right" size="2">{{ customerTransactionEmail.giftCardAmount | currency }}</ion-col>
          <ion-col size="2"></ion-col>
        </ion-row>
      }
      @if (customerTransactionEmail.useGiftCard && !customerTransactionEmail.onlyGiftCard) {
        <ion-row
          class="no-padding fontsizer10">
          <ion-col size="2"></ion-col>
          <ion-col size="6">{{ customerTransactionEmail.translations.creditCard }}</ion-col>
          <ion-col class="right" size="2">{{ customerTransactionEmail.creditCardAmount | currency }}</ion-col>
          <ion-col size="2"></ion-col>
        </ion-row>
      }
      @if (customerTransactionEmail.gainedReward) {
        <ng-container class="fontsizer10">
          <ion-row>
            <ion-col size="12"><hr></ion-col>
          </ion-row>
          <ion-row  class="no-padding fontsizer10">
            <ion-col size="2"></ion-col>
            <ion-col size="6">{{ customerTransactionEmail.translations.rewardCard }}</ion-col>
            <ion-col class="right" size="2">{{ customerTransactionEmail.ghostedRewardCard }}</ion-col>
            <ion-col size="2"></ion-col>
          </ion-row>
          <ion-row class="no-padding fontsizer10">
            <ion-col size="2"></ion-col>
            <ion-col size="6">{{ customerTransactionEmail.translations.gainedPoint }}</ion-col>
            <ion-col class="right" size="2">{{ customerTransactionEmail.gainedPoint }}</ion-col>
            <ion-col size="2"></ion-col>
          </ion-row>
          <ion-row class="no-padding fontsizer10">
            <ion-col size="2"></ion-col>
            <ion-col size="6">{{ customerTransactionEmail.translations.pointBalance }}</ion-col>
            <ion-col class="right" size="2">{{ customerTransactionEmail.pointBalance }}</ion-col>
            <ion-col size="2"></ion-col>
          </ion-row>
        </ng-container>
      }
      <ion-row>
        <ion-col size="12"></ion-col>
      </ion-row>
      <ion-row>
        <ion-col size="12"></ion-col>
      </ion-row>
      <ion-row class="separator"></ion-row>
      <ion-row class="center fontsizer12">
        <ion-col size="12" class="bold">
          {{'Receipt.ImportantNote' | translate}}
        </ion-col>
      </ion-row>
      <ion-row></ion-row>
      <ion-row class="center fontsizer10">
        <ion-col size="12">
          {{'Receipt.OrderConfirmationNote' | translate}}
        </ion-col>
      </ion-row>
      <ion-row></ion-row>
      <ion-row class="center fontsizer10">
        <ion-col size="12">
          {{'Receipt.StorePhoneNumber' | translate}}
          &nbsp;
          <b>{{customerTransactionEmail.storePhone}}</b>
        </ion-col>
      </ion-row>
      <ion-row class="center fontsizer10">
        <ion-col size="12">
          {{'Receipt.IdNote' | translate}}
        </ion-col>
      </ion-row>
      <ion-row class="center fontsizer10">
        <ion-col size="12">
          {{'Receipt.QuestionMayContact' | translate}}
        </ion-col>
      </ion-row>
      <ion-row class="center fontsizer10">
        <ion-col size="12">
          {{'Receipt.ChargeAppearAsFollow' | translate}}
        </ion-col>
      </ion-row>
      <ion-row class="separator"></ion-row>
      <ion-row class="center fontsizer10">
        <ion-col class="bold" size="12">
          {{'Receipt.ShopAchat' | translate}}
        </ion-col>
      </ion-row>
      @if(customerTransactionEmail.info?.formatedAddress) {
        <ion-row class="center fontsizer10">
          <ion-col size="12">
            {{customerTransactionEmail.info.formatedAddress}}
          </ion-col>
        </ion-row>
      }
      
      @if(customerTransactionEmail.info?.contactEmail) {
        <ion-row class="center fontsizer10">
          <ion-col size="12">
            {{'Receipt.Contact' | translate}}: {{customerTransactionEmail.info.contactEmail}}
          </ion-col>
        </ion-row>
      }
      
      @if(customerTransactionEmail.info?.phoneNumber) {
        <ion-row class="center fontsizer10">
          <ion-col size="12">
            {{'Receipt.Tel' | translate}}: {{customerTransactionEmail.info.phoneNumber}}
          </ion-col>
        </ion-row>
      }
      
    </ion-grid>
  </ion-content>